import * as types from "./types";

const initialMeta = { currentPage: 1, count: 0, pages: 1 };

const initialState = {
  rounds: { list: [], meta: initialMeta },
  forms: { list: [], meta: initialMeta },
  formDetails: null,
};

const companyEvaluations = (state = initialState, action) => {
  switch (action.type) {
    // Requests intentionally do NOT clear rounds/forms here: every mount of
    // EvaluationRounds/EvaluationRoundApplicants re-dispatches these even when
    // the data is already loaded (e.g. returning from Evaluate/View Result),
    // and clearing synchronously on request flashed an empty state before the
    // (often identical) response re-populated it a moment later.
    case types.GET_COMPANY_EVALUATIONS_RESPONSE:
      return {
        ...state,
        rounds: { list: action.payload.list, meta: action.payload.meta },
      };
    case types.GET_COMPANY_EVALUATION_FORMS_RESPONSE:
      return {
        ...state,
        forms: { list: action.payload.list, meta: action.payload.meta },
      };
    case types.GET_COMPANY_EVALUATION_FORM_REQUEST:
      return {
        ...state,
        formDetails: null,
      };
    case types.GET_COMPANY_EVALUATION_FORM_RESPONSE:
      return {
        ...state,
        formDetails: action.payload,
      };
    case types.SUBMIT_COMPANY_EVALUATION_FORM_RESPONSE: {
      const updated = action.payload;
      return {
        ...state,
        // Persist full details if the API response included them (questions present)
        formDetails: updated.questions !== undefined ? updated : state.formDetails,
        forms: {
          ...state.forms,
          list: state.forms.list.map((f) =>
            f.id === updated.id
              ? {
                  ...f,
                  status: updated.status,
                  ...(updated.averageRate !== undefined && {
                    averageRate: updated.averageRate,
                  }),
                }
              : f,
          ),
        },
      };
    }
    default:
      return state;
  }
};

export default companyEvaluations;
